import { SVGProps } from 'react';

const SearchFileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.22 8.1 6.573 9.747a2.33 2.33 0 0 0 0 3.3 2.33 2.33 0 0 0 3.3 0l2.594-2.594a4.672 4.672 0 0 0 0-6.6 4.672 4.672 0 0 0-6.6 0L3.04 6.68a4.008 4.008 0 0 0 0 5.66"
    />
  </svg>
);

export default SearchFileIcon;
